import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f70859c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile_detail" }
const _hoisted_2 = { class: "bottom" }
const _hoisted_3 = { class: "tabs" }

import { onMounted, reactive, ref } from 'vue'
import MobileBusiness from './MobileBusiness.vue';
import MobileTreated from './MobileTreated.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileDetail',
  setup(__props) {

const tabRef = ref("tab1");
const pageTopPic = reactive({
  tabs: []
});
const handleChangeTab=(tab: string) =>{
  tabRef.value = tab
}
onMounted(() => {
  if (localStorage.getItem("FUN_ZONE")) {
    pageTopPic.tabs = JSON.parse(localStorage.getItem("FUN_ZONE") || "")
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeTab(`tab1`))),
          class: _normalizeClass(["tab1", tabRef.value === 'tab1' && 'active'])
        }, _toDisplayString(pageTopPic.tabs[0]?.title), 3),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeTab(`tab2`))),
          class: _normalizeClass(["tab2", tabRef.value === 'tab2' && 'active'])
        }, _toDisplayString(pageTopPic.tabs[1]?.title), 3)
      ]),
      (tabRef.value === 'tab1')
        ? (_openBlock(), _createBlock(MobileBusiness, { key: 0 }))
        : (_openBlock(), _createBlock(MobileTreated, { key: 1 }))
    ])
  ]))
}
}

})